module.exports = __webpack_public_path__ + "img/ok.8a588fa5.png";